import React from "react";
import { WithTooltip } from "../../StyledComponents/WithTooltip";
import { CategoryMeta } from "../CategoryMeta";
import { getCategoryIcon } from "../utils";

// styles
import { Wrapper, WidgetHead, WidgetTitle, WidgetContent } from "./styles";

export default function CategoryWidget(props) {
  return (
    <Wrapper>
      <WidgetHead>{getCategoryIcon({ icon: props.icon, color: props.color })}</WidgetHead>
        <WithTooltip
          isNeeded={props?.title.length > 40}
          className="bottom-center"
          content={props?.title}
          size="250px"
        >
          <WidgetTitle>{props?.title}</WidgetTitle>
        </WithTooltip>
        <WithTooltip
          isNeeded={props?.description.length > 60}
          className="bottom-center"
          content={props?.description}
          size="250px"
        >
          <WidgetContent>{props?.description}</WidgetContent>
        </WithTooltip>
        <CategoryMeta categoryData={props} />
    </Wrapper>
  );
}
